import { render } from "./HeroiconsSolidPaperClip.vue?vue&type=template&id=05b9d350"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPaperClip.vue"]])

export default __exports__